var _style, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOxalisSiteWebBoutonsCloseViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.3 28.3",
    style: {
      enableBackground: "new 0 0 28.3 28.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#914E72;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.5,4.5 4.5,6.5 12.2,14.2 4.5,21.9 6.5,23.8 14.2,16.2 21.8,23.8 23.8,21.9 16.1,14.2 23.8,6.6  21.8,4.6 14.2,12.2 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxalisSiteWebBoutonsCloseViolet);
export default __webpack_public_path__ + "static/media/OXALIS_site_web_boutons_close_violet.69d710c96b1912a143f004914bcfed31.svg";
export { ForwardRef as ReactComponent };